import { ResponseCheckToken, RequestCheckToken } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { CheckTokenActions } from '../actions';
import { CheckTokenTypes } from '../../shared/enums';

export interface CheckTokenState {
    response: ResponseCheckToken;
    request: RequestCheckToken;
    error: any;
}

export const CheckTokenInitialState: CheckTokenState = {
    response: null,
    request: null,
    error: null
};

const _checkTokenReducer = createReducer(
    CheckTokenInitialState,

    on(CheckTokenActions.getCheckToken, (state, { request }) => ({
        ...state,
        request,
        error: null
    })),

    on(CheckTokenActions.getCheckTokenSuccess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(CheckTokenActions.getCheckTokenError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(CheckTokenActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function checkTokenReducer(state, action) {
    if (action.type === CheckTokenTypes.CHECK_TOKEN) {
        state = undefined;
    }
    return _checkTokenReducer(state, action);
}
